import {
  batch,
  createCorpHeadersMiddleware as withHeadersMiddleware,
  fetch as fetchBase,
} from '@yandex-delivery/core/utils/network'
import {pipe} from '@yandex-delivery/utils'

import {useConfigContext} from '../../contexts/ConfigContext'
import {withCsrfMiddleware} from '../fetch'

type FetchFunction = typeof fetchBase
type UseFetchReturn = {
  fetch: FetchFunction
  passportFetch: FetchFunction
}

type PassportMiddlewareParams = {
  host: string
}

// пока что миддлвара будет жить тут, наверно до тех пока "auth" не начнет использовать сервис регистрации
function withPassportMiddleware({host}: PassportMiddlewareParams) {
  return function _withPassportMiddleware(fetchFn: FetchFunction): FetchFunction {
    return function passportFetch(config) {
      return fetchFn({
        ...config,
        url: `${host}${config.url}`,
        options: {
          credentials: 'include',
        },
      })
    }
  }
}

type AccountRedirectMiddlewareParams = {
  accountUrl: string
}

function withAccountRedirectMiddleware({accountUrl}: AccountRedirectMiddlewareParams) {
  return function _withAccountRedirectMiddleware(fetchFn: FetchFunction): FetchFunction {
    return function _withAccountRedirectMiddlewareFunction(config) {
      return fetchFn(config).catch(error => {
        if (error.status === 410) {
          window.location.href = accountUrl
          return error
        }
        throw error
      })
    }
  }
}

export const useFetch = (): UseFetchReturn => {
  const {accountUrl, lang, passportApiHost, version} = useConfigContext()

  const fetch = pipe(
    fetchBase,
    withCsrfMiddleware,
    withAccountRedirectMiddleware({accountUrl}),
    withHeadersMiddleware({
      version,
      lang,
      getURI() {
        return `${window.location.origin}${window.location.pathname}`
      },
    }),
    batch,
  ) as FetchFunction

  const passportFetch = pipe(
    fetchBase,
    withPassportMiddleware({
      host: passportApiHost,
    }),
  ) as FetchFunction

  return {fetch, passportFetch}
}
